import {
  PUBLIC_FAQS_REQUEST,
  PUBLIC_FAQS_SUCCESS,
  PUBLIC_FAQS_FAIL,
  ADMIN_FAQS_REQUEST,
  ADMIN_FAQS_SUCCESS,
  ADMIN_FAQS_FAIL,
  FAQ_DETAILS_REQUEST,
  FAQ_DETAILS_SUCCESS,
  FAQ_DETAILS_FAIL,
  NEW_FAQ_REQUEST,
  NEW_FAQ_SUCCESS,
  NEW_FAQ_FAIL,
  NEW_FAQ_RESET,
  FAQ_UPDATE_REQUEST,
  FAQ_UPDATE_SUCCESS,
  FAQ_UPDATE_FAIL,
  FAQ_UPDATE_RESET,
  FAQ_DELETE_REQUEST,
  FAQ_DELETE_SUCCESS,
  FAQ_DELETE_FAIL,
  FAQ_DELETE_RESET,
  FAQ_STATUS_REQUEST,
  FAQ_STATUS_SUCCESS,
  FAQ_STATUS_FAIL,
  FAQ_STATUS_RESET,
  CLEAR_ERRORS,
} from "../constants/faqConstants";

// Public FAQs reducer
export const faqsReducer = (state = { faqs: [] }, action) => {
  switch (action.type) {
    case PUBLIC_FAQS_REQUEST:
      return {
        loading: true,
        faqs: [],
      };
    case PUBLIC_FAQS_SUCCESS:
      return {
        loading: false,
        faqs: action.payload,
      };
    case PUBLIC_FAQS_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Admin FAQs reducer
export const adminFaqsReducer = (state = { faqs: [] }, action) => {
  switch (action.type) {
    case ADMIN_FAQS_REQUEST:
      return {
        loading: true,
        faqs: [],
      };
    case ADMIN_FAQS_SUCCESS:
      return {
        loading: false,
        faqs: action.payload,
      };
    case ADMIN_FAQS_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// FAQ details reducer
export const faqDetailsReducer = (state = { faq: {} }, action) => {
  switch (action.type) {
    case FAQ_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FAQ_DETAILS_SUCCESS:
      return {
        loading: false,
        faq: action.payload,
      };
    case FAQ_DETAILS_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// New FAQ reducer
export const newFaqReducer = (state = { faq: {} }, action) => {
  switch (action.type) {
    case NEW_FAQ_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case NEW_FAQ_SUCCESS:
      return {
        loading: false,
        success: action.payload.success,
        faq: action.payload.faq,
      };
    case NEW_FAQ_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case NEW_FAQ_RESET:
      return {
        ...state,
        success: false,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// FAQ update reducer
export const updateFaqReducer = (state = {}, action) => {
  switch (action.type) {
    case FAQ_UPDATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FAQ_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload,
      };
    case FAQ_UPDATE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case FAQ_UPDATE_RESET:
      return {
        ...state,
        success: false,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// FAQ delete and status reducer
export const faqReducer = (state = {}, action) => {
  switch (action.type) {
    case FAQ_DELETE_REQUEST:
    case FAQ_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FAQ_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        isDeleted: action.payload,
      };
    case FAQ_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        isStatusUpdated: action.payload,
      };
    case FAQ_DELETE_FAIL:
    case FAQ_STATUS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case FAQ_DELETE_RESET:
      return {
        ...state,
        isDeleted: false,
      };
    case FAQ_STATUS_RESET:
      return {
        ...state,
        isStatusUpdated: false,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};
